import type { InviteConfirmTarget } from '../types/slotInvite'
import { balanceLabel, balanceText } from './balanceI18n'

/**
 * Jeff, Oct 1 — what an invited slot's Cancel Invite and Delete Slot ask, naming who
 * the slot is held for. Cancelling keeps the slot (and its share) and opens it back
 * up; deleting removes it. Either way the person's link stops working.
 */
export const inviteConfirmCopy = (
  target: InviteConfirmTarget
): {
  title: string
  description: string
  confirmLabel: string
  cancelLabel: string
} => {
  if (target.kind === 'cancel') {
    return {
      title: balanceLabel('common:balanceInviteCancelTitle'),
      description: balanceText('common:balanceInviteCancelBody', {
        name: target.name,
      }),
      confirmLabel: balanceText('common:balanceInviteCancel').toUpperCase(),
      cancelLabel: balanceText('common:balanceInviteKeep').toUpperCase(),
    }
  }

  return {
    title: balanceLabel('common:balanceInviteDeleteTitle'),
    description: balanceText('common:balanceInviteDeleteBody', {
      name: target.name,
    }),
    confirmLabel: balanceText('common:deleteSlot').toUpperCase(),
    cancelLabel: balanceText('common:balanceCommsCancel').toUpperCase(),
  }
}
